import { render, staticRenderFns } from "./ContractTypeForm.vue?vue&type=template&id=34f1bcf8"
import script from "./ContractTypeForm.vue?vue&type=script&lang=js"
export * from "./ContractTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports